import useSeo from "@/hooks/useSeo";
import PageHeader from "@/components/feature/PageHeader";
import TopicGrid from "@/pages/topics/components/TopicGrid";
import { topics } from "@/mocks/topics";

const topicsJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "热梗库",
    url: "https://law818.cn/topics",
    inLanguage: "zh-CN",
    description: "按热梗追踪、表情包、二创二改、评论神评等分区整理的网络热梗合集。",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://law818.cn/" },
      { "@type": "ListItem", position: 2, name: "热梗库", item: "https://law818.cn/topics" },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "热梗整理列表",
    numberOfItems: topics.length,
    itemListElement: topics.map((topic, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: topic.title,
      url: `https://law818.cn/topics/${topic.id}`,
    })),
  },
];

export default function Topics() {
  useSeo({
    title: "热梗库 | 后续梗追踪与二创合集 - 513吃瓜",
    description:
      "513吃瓜热梗库按热梗追踪、表情包、二创二改、评论神评等分区整理网络热梗，附热度榜与后续进展，帮你快速看懂一个梗的全过程。",
    keywords: "513吃瓜热梗库,后续梗,网络热梗合集,二创二改,表情包出处",
    path: "/topics",
    jsonLd: topicsJsonLd,
  });

  return (
    <>
      <PageHeader
        eyebrow="每日更新"
        title="热梗库"
        desc="这里按主题分区整理了当下最值得追的梗：从它怎么火起来，到后来被玩成了什么样，一条一条给你讲清楚。"
        crumbs={[{ label: "首页", path: "/" }, { label: "热梗库" }]}
      />
      <TopicGrid />
    </>
  );
}